import React from 'react';
import {BreadcrumbViewProps, PageLayout} from '../../Layouts/PageLayout';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {replaceUser, UserApp} from '../../Context/AuthProvider/AuthProviderActions';
import {createUser, getNewUser, getUserById, getUserKeys, updateUser} from '../../Actions/Users/UsersActions';
import {QueryResponse, useParameterizedQuery} from 'react-fetching-library';
import {Tabs, TabsProps} from 'antd';
import {useAuthDispatch, useAuthState} from '../../Context/AuthProvider/AuthProvider';
import {UserAvatarForm} from '../../Context/AuthProvider/UserAvatarForm';
import {UserAppFromAdminResponse} from '../../Actions/Users/UsersDomain';
import {AddOrEditTabElement} from './Tabs/AddOrEditTabElement/AddOrEditTabElement';
import {EditeGlobalUserTabElement} from './Tabs/EditeGlobalUserTabElement/EditeGlobalUserTabElement';
import {AcystID} from '../../Config/ConfigConstants';
import {addAlert} from "../../Context/AlertProvider/AlertProviderActions";
import {useAlertDispatcherState} from "../../Context/AlertProvider/AlertProvider";

export const UserFormPage:React.FunctionComponent = (_props) => {
    const [title, setTitle] = React.useState<string>('Nuevo Usuario');
    const [oldPath, setOldPath] = React.useState<string>('Nuevo Usuario');

    const [tipLoading, setTipLoading] = React.useState<string>();

    const [activeLoading, setActiveLoading] = React.useState<boolean>(false);

    const [userData, setUserData] = React.useState<UserApp>(getNewUser());
    const [keys, setKeys] = React.useState<number[]>([]);

    const [isLoadingKeys, setIsLoadingKeys] = React.useState<boolean>(false);
    const [isLoadingUser, setIsLoadingUser] = React.useState<boolean>(false);
    const [initLoader, setInitLoader] = React.useState<boolean>(false);

    const getUserByIdAction = useParameterizedQuery(getUserById);
    const  getUserKeysAction = useParameterizedQuery(getUserKeys);

    const updateUserAction = useParameterizedQuery(updateUser);
    const createUserAction = useParameterizedQuery(createUser);

    const authDataState = useAuthState();
    const authDispatch = useAuthDispatch();

    const [breadcrumbs, setBreadcrumbs] = React.useState<BreadcrumbViewProps[]>([
        {title: 'Administración de Usuarios'},
    ]);

    const alertDispatcher = useAlertDispatcherState();

    const location = useLocation();
    const currentPath = React.useMemo(() => {
        // Se elimina el primer elemento vacío y se obtiene el siguiente segmento
        const parts = location.pathname.split('/').filter(Boolean);
        return parts[0] || '';
    }, [location.pathname]);

    const { userID, tabKey } = useParams();
    const navigate = useNavigate();

    const isLoading = React.useMemo(()=>{
        return getUserByIdAction.loading || updateUserAction.loading || createUserAction.loading || activeLoading;
    }, [activeLoading, createUserAction.loading, getUserByIdAction.loading, updateUserAction.loading]);

    const activeTab = React.useMemo( ()=>{
        if (tabKey === undefined) return 'informacion-base';
        return tabKey;
    }, [tabKey] );

    React.useEffect( ()=>{
        if (userID !== undefined){
            const userIdInt = parseInt(userID);
             if (userIdInt > 0){
                 if (!isLoadingUser && initLoader){
                     setIsLoadingUser(true);
                     setTipLoading('Obteniendo información del usuario...');
                     getUserByIdAction.query(userIdInt).then(r=>{
                         if (r.payload && !r.payload.error['has-error']){
                             setUserData(r.payload.response.user);
                             setKeys(r.payload.response.keys);
                         }

                         setIsLoadingKeys(true);
                     });
                 }

                 return;
             }
        }
    }, [getUserByIdAction, isLoadingUser, userID, currentPath, initLoader] );

    React.useEffect( ()=>{
        if (userData.id > 0){
            setTitle(`Editar Usuario "${ userData.clave }"`);
            setBreadcrumbs([
                {title: 'Administración de Usuarios', path: '/' },
                {title: userData.clave}
            ]);
        }else{
            if (!isLoadingKeys && initLoader){
                setIsLoadingKeys(true);
                setTipLoading('Obteniendo información del servisdor...');

                setTitle('Agregar Usuario');
                setBreadcrumbs([
                    {title: 'Administración de Usuarios', path: '/' },
                    {title: 'Agregar Usuario'}
                ]);

                getUserKeysAction.query({}).then(r=>{
                    console.log('-----> ', r.payload);
                    if (r.payload && !r.payload.error['has-error']){
                        setKeys(r.payload.response);

                        if (r.payload.response.length === 0){
                            addAlert('Error', 'No tienes llaves disponibles para terminar esta acción', 'error', alertDispatcher);
                        }
                    }
                });
            }
        }
    }, [getUserKeysAction, initLoader, isLoadingKeys, userData] );


    const manageEditeRequest = React.useCallback( (r:QueryResponse<UserAppFromAdminResponse>) => {
        if (r.payload && !r.payload.error['has-error']) {
            const response = r.payload.response;
            setKeys(response.keys);
            setUserData(response.user);

            replaceUser(response.user, authDispatch).then();
        }
    }, [authDispatch] );

    const updateDiazarUserFunc = React.useCallback( (updateUser:UserApp)=>{
        setTipLoading('Actualizando la información del usuario...');
        updateUserAction.query(updateUser).then( r => {
            manageEditeRequest(r);
        } );
    } , [manageEditeRequest, updateUserAction] );

    const createDiazarUserFunc = React.useCallback( (updateUser:UserApp)=>{
        setTipLoading('Actualizando la información del usuario...');
        setUserData(updateUser);
        createUserAction.query(updateUser).then( r => {
            if (r.payload && !r.payload.error['has-error']) {
                const userInfo = r.payload.response;
                if (userInfo.id > 0){
                    navigate(`/edit-user/${ userInfo.id }`);
                }
            }
        } );
    } , [createUserAction, navigate] );

    const TabsItems : TabsProps['items'] = React.useMemo( ()=>{
        const isMy = authDataState.user !== undefined && authDataState.user.id === userData.id;
        const isMigrated = authDataState.company !== undefined && (authDataState.company.isMigrated || authDataState.company.id === AcystID);

        const tabs: TabsProps['items'] = [
            {
                key: 'informacion-base',
                label: 'Información Base',
                children: <AddOrEditTabElement user={userData}
                                               keys={keys}
                                               setIsLoading={setActiveLoading}
                                               saveDiazarUserFunc={(userData.id !== 0) ? updateDiazarUserFunc : createDiazarUserFunc}
                                               setUser={setUserData} isLoading={activeLoading}
                                               isLoadingKeys={isLoadingKeys}
                                               isLoadingUser={isLoadingKeys}
                />
            }
        ];

        if (isMigrated && userID !== undefined){

            tabs.push({
                key: 'usuario-global',
                label: 'Usuario Global',
                children: <EditeGlobalUserTabElement isLoading={activeLoading} setIsLoading={ setActiveLoading } />,
                disabled: !isMy,
            });
        }

        if (userData.id > 0){
            tabs.push({
                key: 'seguridad',
                label: 'Seguridad',
                children: <h1>Tab 3</h1>,
                disabled: !isMy,
            });
        }

        return tabs;
    }, [authDataState.user, authDataState.company, userData, keys, updateDiazarUserFunc, createDiazarUserFunc, activeLoading, isLoadingKeys, userID] );

    React.useEffect( ()=>{
        if(currentPath !== oldPath){
            setOldPath(currentPath);
            setIsLoadingUser(false);
            setIsLoadingKeys(false);
            setInitLoader(false);
        }else{
            setInitLoader(true);
        }
    }, [currentPath, oldPath] );

    return (
        <PageLayout
            disableOtherItems
            title={title}
            breadcrumbItems={breadcrumbs}
            isLoading={ isLoading }
            loadingTip={ tipLoading }
        >

            <UserAvatarForm
                user={ userData }
                setUser={setUserData}
                setKeys={ setKeys }
                setIsLoading={ setActiveLoading }
                setLoadingMsg={ setTipLoading }
                manageRequest={ manageEditeRequest }
            />

            <Tabs defaultActiveKey={ activeTab } items={ TabsItems } onChange={ ak => navigate(`/edit-user/${ userData.id }/${ ak}`) } />
        </PageLayout>
    );
};
